// Menunav.jsx
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import AuthMenu from "./AuthMenu";

export default function MenuNav() {
  const location = useLocation();
  const closeOffcanvas = () => {
    const backdrop = document.querySelector(".offcanvas-backdrop");
    const body = document.body;
    const offcanvas = document.querySelector(".offcanvas.show");

    if (backdrop) backdrop.remove();
    if (body.classList.contains("offcanvas-backdrop")) body.classList.remove("offcanvas-backdrop");
    if (body.classList.contains("modal-open")) body.classList.remove("modal-open");
    if (offcanvas) offcanvas.classList.remove("show");
    body.style.overflow = "";
  };

  const isActive = (path) =>
    location.pathname.startsWith(path) || location.pathname === path;
  const matchPath = (path) =>
    location.pathname.startsWith(path) || location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky-top py-2 px-4" style={{ borderBottom: "1px solid #ddd" }}>
      <div className="d-flex justify-content-between align-items-center">
        <NavLink
          to="/"
          className="h3 text-primary fw-bold mb-0 text-decoration-none"
          style={{ padding: "4px 8px" }}
        >

          <img
            src="/logo192.jpeg"
            alt="Logo LAFAPE"
            style={{ height: "48px", width: "auto", objectFit: "contain" }}
            loading="lazy"
          />
        </NavLink>
        {/* Conteneur central pour regrouper menu + Auth */}
        <div className="d-flex align-items-center ms-auto gap-3">
          {/* Menu Desktop rapproché */}
          <nav className="d-none d-md-flex gap-2 align-items-center">
            <NavLink to="/" className={({ isActive }) => `btn btn-sm fw-medium ${isActive ? "btn-bridge" : "btn-bridge-outline"}`} onClick={closeOffcanvas}>
              Accueil
            </NavLink>
            <NavLink to="/catalogue" className={() =>
              `btn btn-sm fw-medium ${isActive("/marques") || isActive("/catalogue") || isActive("/vehicules")
                ? "btn-bridge"
                : "btn-bridge-outline"
              }`} onClick={closeOffcanvas}>
              Machines Agricoles
            </NavLink>
            {/* 👇 Ajout du lien vers les véhicules à louer */}
            <NavLink
              to="/colisage"
              className={() =>
                `btn btn-sm fw-medium ${matchPath("/colisage") || matchPath("/reservation")
                  ? "btn-bridge"
                  : "btn-bridge-outline"
                }`
              }
            >
              Colisage & Suivi
            </NavLink>

            <NavLink to="/a-propos" className={({ isActive }) => `btn btn-sm fw-medium ${isActive ? "btn-bridge" : "btn-bridge-outline"}`} onClick={closeOffcanvas}>
              A propos
            </NavLink>
            <NavLink to="/contact" className={({ isActive }) => `btn btn-sm fw-medium ${isActive ? "btn-bridge" : "btn-bridge-outline"}`} onClick={closeOffcanvas}>
              Contact
            </NavLink>
          </nav>

          {/* Auth menu + Burger button */}
          <div className="d-flex align-items-center gap-2">
            <AuthMenu />
            <button
              className="btn btn-outline-dark d-md-none"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#mobileMenu"
              aria-controls="mobileMenu"
            >
              <i className="bi bi-list fs-4"></i>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
